import React, { useState } from 'react';
import { useDispatch } from 'react-redux';
import CommentSection from './CommentSection'; // 분리한 댓글 섹션 불러오기
import { styles } from './TopicStyles'; // 분리한 스타일 불러오기
import { submitReport } from '../../slices/reportsSlice';
import { updatePoints } from '../../slices/authSlice';

const PostModal = ({ post, user, onClose, topicId }) => {

  const dispatch = useDispatch();
  const [showReportModal, setShowReportModal] = useState(false);
  const REPORT_REASONS = [
    "스팸/광고성 글",
    "욕설/비방/혐오 표현",
    "개인정보 노출",
    "주제와 무관한 내용",
    "허위 사실",
    "소속 진영과 안 맞는 내용",
    "기타"
  ];

  // post 데이터가 없으면 아무것도 렌더링하지 않음
  if (!post) return null;

  const handleReportSubmit = (reason) => {
    dispatch(submitReport({
      targetType: 'Post',
      targetId: post._id,
      reason: reason
    })).unwrap()
    .then((res) => {

      if (res.updatedPoints !== undefined) {
        dispatch(updatePoints({ points: res.updatedPoints }));
      }

      alert("게시글이 신고되었습니다.");
      setShowReportModal(false);
    })
    .catch(err => alert(err.message || "이미 신고한 게시글입니다."));
  };

  const getToxicityColor = (score) => {
    if (score > 0.7) return '#ff4e50'; // Red for high toxicity
    if (score > 0.4) return '#ffd700'; // Yellow for medium toxicity
    return '#00d4ff'; // Blue for low toxicity
  }

  return (
    <div style={styles.modalOverlay} onClick={onClose}>
      <div style={styles.modalContent} onClick={(e) => e.stopPropagation()}>
        
        {/* 1. 모달 헤더 */}
        <div style={styles.modalHeader}>
          <span style={post.faction === 'BLUE' ? styles.blueText : styles.redText}>
            {post.faction} LOGIC ANALYSIS
          </span>
          <button onClick={onClose} style={styles.closeBtn}>✕</button>
        </div>

        {/* 2. 작성자 및 날짜 정보 */}
        <div style={{
          marginTop: '12px',
          marginLeft: '20px',
          display: 'flex',
          alignItems: 'center',
          gap: '12px',
          fontSize: '0.85rem',
          color: '#aaa',
          fontFamily: 'sans-serif'
        }}>
          <span>By <strong style={{ color: post.faction === 'BLUE' ? '#00d4ff' : '#ff4e50' }}>{post.authorId?.nickname}</strong></span>
          <span style={{ width: '1px', height: '12px', backgroundColor: '#444' }}></span>
          <span>{new Date(post.createdAt).toLocaleDateString()}</span>
        
          {/* 신고 버튼 */}
          <button style={styles.reportBtn} onClick={() => setShowReportModal(true)}>
             🚩 신고하기(30P 차감)
          </button>

          {/* 독성 지수 표시 */}
          <span style={{ fontSize: '0.85rem', fontWeight: 'bold', color: getToxicityColor(post.perspectiveScore?.total) }}>
            오염도(AI): {(post.perspectiveScore?.total * 100).toFixed(1)}%
          </span>
        </div>


        {/* 3. 본문 내용 및 댓글 섹션 */}
        <div style={styles.modalBody}>
          
          <p style={styles.selectedContent}>{post.content}</p>
          <hr style={styles.divider} />
          
          {/* 분리된 CommentSection을 호출 (topicId는 MyPage 배려를 위해 fallback 설정) */}
          <CommentSection 
            postId={post._id} 
            user={user} 
            topicId={topicId || post.topicId?._id || post.topicId} 
          />
        </div>

        {/* 게시글 신고 모달 */}
        {showReportModal && (
          <div style={styles.reportModalOverlay}>
            <div style={styles.reportModalContent}>
              <h4>게시글 신고 사유</h4>
              <ul style={styles.reasonList}>
                {REPORT_REASONS.map(reason => (
                  <li key={reason} style={styles.reasonItem} onClick={() => handleReportSubmit(reason)}>
                    {reason}
                  </li>
                ))}
              </ul>
              <button style={styles.cancelBtn} onClick={() => setShowReportModal(false)}>취소</button>
            </div>
          </div>
        )}

      </div>
    </div>
  );
};

export default PostModal;